import { CategoryColumn } from './category-column';
import { CategoryColumnComponent } from './category-column.component';
import { FormField } from '../../common/register/form-field';

export class Category extends FormField {
  constructor(item, header) {
    super(item, header);
    this.expandable = true;

    this.grid = [
      header.columns.map((headerColumn) => new CategoryColumn(item, headerColumn, CategoryColumnComponent)),
    ];
  }
}
